import { callAPI } from '../../network/networkConnection';
const BASE_URL = process.env.REACT_APP_APIUrl + "admin";

// create new restricted word
export const createRestrictedWord = (data) => {
    return callAPI(
        `${BASE_URL}/restricted-words`,
        "POST",
        { "Content-Type": "application/json" },
        JSON.stringify(data)
    );
}

// update existing restricted word
export const updateRestrictedWord = (id, data) => {
    return callAPI(
        `${BASE_URL}/restricted-words/${id}`,
        "PUT",
        { "Content-Type": "application/json" },
        JSON.stringify(data)
    );
}

// hard delete restricted word
export const hardDeleteRestrictedWord = (id) => {
    return callAPI(
        `${BASE_URL}/restricted-words/${id}`,
        "DELETE",
        { "Content-Type": "application/json" }
    )
}

// soft delete restricted word
export const softDeleteRestrictedWord = (id) => {
    return callAPI(
        `${BASE_URL}/restricted-words/${id}/soft-delete`,
        "PATCH",
        { "Content-Type": "application/json" }
    )
}

// fetch list
export const fetchRestrictedWords = (page, limit) => {
    return callAPI(
        `${BASE_URL}/restricted-words?page=${page}&limit=${limit}`,
        "GET",
        { "Content-Type": "application/json" }
    )
}

